<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>Courses of {{ participant.fullName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <AdvancedTableFilters v-model="filters" :schema="filterSchema" :applyOnChange="true" @apply="onApplyFilters" />
    </v-toolbar>
    <v-data-table
      v-bind="$attrs"
      v-on="$listeners"
      :items="filteredPromotionCourses"
      :headers="headers"
      :loading="loading"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="{ name: 'course', params: { id: item.course.id } }">
          {{ item.course.name }}
        </router-link>
        <span v-if="item.course.description">
          <br />
          {{ item.course.description }}
        </span>
      </template>
      <template v-slot:item.passingGrade="{ item }">
        {{
          item.overridePassingGrade
            ? item.overridePassingGrade
            : item.course.passingGrade
            ? item.course.passingGrade
            : "N/A"
        }}
      </template>
      <template v-slot:item.completed="{ item }">
        <v-icon v-if="item.completedDate" color="green">mdi-check</v-icon>
        <v-icon v-else color="red">mdi-close</v-icon>
        {{ item.completedDate | formatDateClient("MM/DD/YYYY", selectedClient) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AdvancedTableFilters from "./advancedTableFilters/AdvancedTableFilters.vue";
import { mapGetters } from "vuex";

export default {
  name: "PromotionCoursesParticipantTable",
  props: {
    promotion: Object,
    participant: Object
  },
  components: {
    AdvancedTableFilters
  },
  data() {
    return {
      loading: false,
      promotionCourses: [],
      courseGrades: [],
      headers: [
        {
          value: "name",
          text: "Promotion Course",
          sortable: true
        },
        {
          value: "completed",
          text: "Completed?",
          sortable: true,
          align: "right"
        }
      ],
      filters: {},
      filterSchema: [
        {
          key: "effective",
          label: "Status",
          type: "effective"
        },
        {
          key: "completed",
          label: "Completed?",
          type: "select",
          items: [
            { text: "Complete", value: true },
            { text: "Incomplete", value: false },
            { text: "All", value: null }
          ]
        },
        {
          key: "course",
          label: "Course",
          type: "byCourse"
        }
      ]
    };
  },
  methods: {
    async fetchPromotionCourses() {
      let filters = {
        effective: this.filters.effective
      };
      if (!this.promotion || !this.promotion.id) {
        this.promotionCourses = [];
        return Promise.resolve();
      }

      if (this.filters?.course?.id) {
        filters.course = { id: this.filters?.course?.id };
      }

      filters.promotion = { id: this.promotion.id };
      let { data: promotionCourses } = await this.$api.post("/api/promotionCourses/search?size=100", filters);
      this.promotionCourses = promotionCourses.content;
    },
    fetchCourseGrades(page = 0) {
      if (!this.participant || !this.participant.id) {
        this.courseGrades = [];
        return Promise.resolve();
      }
      let allGrades = [];
      const fetchPage = pageNum => {
        return this.$api
          .post(`/api/courseGrades/search?page=${pageNum}&size=500`, { participant: { id: this.participant.id } })
          .then(({ data }) => {
            if (data.content && data.content.length > 0) {
              allGrades = allGrades.concat(data.content);
            }

            if (!data.last) {
              return fetchPage(pageNum + 1);
            } else {
              this.courseGrades = allGrades;
            }
          });
      };

      return fetchPage(page);
    },

    async fetchData() {
      this.loading = true;
      try {
        await this.fetchPromotionCourses();
        await this.fetchCourseGrades();
      } finally {
        this.loading = false;
      }
    },

    async onApplyFilters() {
      await this.fetchData();
    }
  },
  computed: {
    ...mapGetters(["selectedClient", "selectedProgram"]),
    filteredPromotionCourses() {
      if (this.filters?.completed === true) {
        return this.matchedCourseGradeWithPromotionCourses.filter(pc => pc.completedDate !== false);
      } else if (this.filters?.completed === false) {
        return this.matchedCourseGradeWithPromotionCourses.filter(pc => pc.completedDate === false);
      }
      return this.matchedCourseGradeWithPromotionCourses;
    },
    matchedCourseGradeWithPromotionCourses() {
      this.promotionCourses.forEach(pc => {
        const cg = this.courseGrades.find(cg => cg.course.id === pc.course.id);
        if (cg) {
          pc.grade = cg.grade;
          pc.completedDate = cg.completedDate;
        } else {
          pc.grade = null;
          pc.completedDate = false;
        }
      });
      return this.promotionCourses;
    }
  },
  mounted() {
    this.filters = {
      effective: true
    };
    this.fetchData();
  }
};
</script>
